import { put, call, takeLatest } from "redux-saga/effects";
import * as API from "services";
import * as Actions from "actions";
import { DeliveryStatusDashboard } from "constants/Actions";
import { formatStatusList } from "functions"

const { deliveryStatusDashboard } = Actions;

const { statusDetails, statusList } = API.deliveryStatusDashboard;

const { GET_DASHBOARD_STATUS_DETAILS, GET_DELIVERY_STATUS_LIST } =
  DeliveryStatusDashboard;

const deliveryStatusSagas = {
  statusList: {
    get: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(statusList.get, params);
        if (Array.isArray(data) && status === 200) {
          yield put(deliveryStatusDashboard.deliveryStatus.success(formatStatusList(data, params.statusType)));
        } else {
          yield put(deliveryStatusDashboard.deliveryStatus.fail([]));
        }
      } catch (error) {
        yield put(deliveryStatusDashboard.deliveryStatus.fail(error as any));
      }
    },
  },
  statusDetails: {
    get: function* (action: any) {
      try {
        const params = action?.payload.data ?? {};
        const { data, status } = yield call(statusDetails.get, params);
        if (Array.isArray(data) && status === 200) {
          yield put(
            deliveryStatusDashboard.deliveryStatusDetails.success(data)
          );
        } else {
          yield put(deliveryStatusDashboard.deliveryStatusDetails.fail({}));
        }
      } catch (error) {
        yield put(
          deliveryStatusDashboard.deliveryStatusDetails.fail(error as any)
        );
      }
    },
  },
};

export default [
  takeLatest(GET_DELIVERY_STATUS_LIST, deliveryStatusSagas.statusList.get),
  takeLatest(
    GET_DASHBOARD_STATUS_DETAILS,
    deliveryStatusSagas.statusDetails.get
  ),
];
